import React, { Component } from 'react';
import './now.css';

class Now extends Component {
  render() {
    return (
      <div className="now">
        <h4>Now</h4>
        <p>What am I reading?</p>
        <p>Tools of Titans, The Metropolitan Man</p>

        <p>What am I working on?</p>
        <p>I have three projects I work on free time, that helps me to maintain interest when I hit boring <small>*cough*signup pages*cough*</small> parts of any project.</p>

        <h4>1. Kawasaki and Arduino</h4>
        <p>Connect motorcycle to computer with Arduino and couple of cables.</p>
        <p>Current progress: cables assembled, chips soldered, time for testing!</p>

        <h4>2. Magic Mirror</h4>
        <p>Build mirror with display behind to show cool stuff (cool stuff not defined yet). Use camera for Person Identification, microphone for voice commands.</p>
        <p>Current progress: Update code to work with higher-end camera and microphone</p>

        <h4>3. Game to help learn Chinese Hanzi</h4>
        <p>I've always felt there's no good game that takes advantage of amazingness of Chinese language. I'm trying multittude of prototypes to test if I can change that.</p>
        <p>Current progress: polish and publish Puzzle prototype. The proper game is stuck on "I need good assets" stage.</p>

        <p>If you have questions about any of above, <a href="#contact" title="contact">contact me</a></p>
        <p>Inspired by <a href="https://sivers.org/nowff" title="Now history">Derek Sivers</a></p>
        <p>Updated: January 2017</p>
      </div>
    );
  }
}

export default Now;



/** WEBPACK FOOTER **
 ** ./src/now/now.js
 **/